module.exports = "<div class=\"checkout-base\">\r\n    <h1 class=\"sr-only\">Checkout</h1>\r\n\r\n    <div ui-view=\"rr-instrumentation-panel\"></div>\r\n    <wow-checkout-header></wow-checkout-header>\r\n\r\n    <div ui-view=\"checkout-content\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/checkout/views/checkout.view.html
// module id = 629
// module chunks = 0